/*
 * @Description: 
 * @Author: zhanghao
 * @Date: 2025-03-18 10:58:47
 * @LastEditTime: 2025-03-25 14:25:38
 * @LastEditors: zhanghao
 */
export { EResponseCode } from './responseCode';

// 接口请求超时时间
export const DefaultTimeout = 30000;
// Sentry接口上报超时时间
export const SentryTimeout = 20000;
/** md5 盐 */
export const SIGN_SALT = '95b9a5528d3e4d03958355e2dc8c4867';
export const SCORE_DESC = ['1分', '2分', '3分', '4分', '5分'];

export const SCORE_DESC_ENUM= {
    1: '1分',
    2: '2分',
    3: '3分',
    4: '4分',
    5: '5分'
};
